'use strict';

/* Controllers */

app.controller('MoneyCartController', ['$scope', '$rootScope', '$location', 'Cart', 'User', 'Payment', 'Helper', 'Braintree', 'Preloader', 'Popup', 
    function ($scope, $rootScope, $location, Cart, User, Payment, Helper, Braintree, Preloader, Popup) {

        // pass service to scope
        $scope.User = User;

        // init vars
        var paypal_checkout = null;

    	// init scope vars
        $scope.processing_payment = false;
    	$scope.getting_token      = true;
    	$scope.selectedUser       = $rootScope.globals.selectedUser;
        $scope.currency_symbol    = $rootScope.globals.currentUser.credit.symbol;

    	$scope.money_amount       = $rootScope.globals.selectedMoney.amount;

    	if( typeof $rootScope.globals.cartData == 'undefined' ||  
            typeof $rootScope.globals.cartData.personal_message == 'undefined' ){
            $rootScope.globals.cartData = {
                personal_message: '',
            };
        }


        // run on page init
        initBraintree();


        /**
         * function that is run when user clicks on
         * pay with waave credit button
         */
        $scope.payWithWaaveCredit = function() {
            // save data to storage
            Helper.updateLocalStorageWithGlobalVariable();

            $scope.processing_payment = true;

            // make payment
            Payment.make('waave_credit', 'money', function(resp, status){

                if( status == 200 ){
                    // success, show receipt to user
                    $location.path('/money-receipt');
                }
                else{
                    // check for errors
                    switch(status){
                        case 402:
                            Popup.error('You need additional WAAVE credits to complete this purchase.');
                            break;

                        default:
                            Popup.error('Something went wrong :(');
                            break;
                    }
                }

                $scope.processing_payment = false;
            });
        }


    	/**
    	 * function that is run when user clicks on
    	 * pay with PayPal button
    	 */
    	$scope.payWithPayPal = function(paypal_object) {
            
            // if clicked first init paypal,
            if( typeof paypal_object == 'undefined' ){
                paypal_checkout.paypal.initAuthFlow();
                return;
            }

            // this will run next time this function
            // is called with paypal_object
            
            // save paypal_object in $rootScope
            $rootScope.braintree = {
                paypal_object: paypal_object
            };

    		// save data to storage
    		Helper.updateLocalStorageWithGlobalVariable();

    		$scope.processing_payment = true;

    		// make payment
    		Payment.make('paypal', 'money', function(resp, status){

    			if( status == 200 ){
    				// success, show receipt to user
    				$location.path('/money-receipt');
    			}
    			else{
    				// check for errors
	    			switch(status){
                        case 400:
                            Popup.error(resp.message);
                            break;

                        default:
                            Popup.error('Something went wrong :(');
                            break;
	    			}
    			}

    			$scope.processing_payment = false;
    		});
    	}


        /**
         * function that is run when user clicks on
         * pay with Credit Card button
         */
        $scope.payWithCreditCard = function(){
            Helper.updateLocalStorageWithGlobalVariable();
            
            $location.path('/money-credit-card-payment');
        }



        /**
         * init braintree on page load
         */
        function initBraintree(){

            Braintree.getToken(function(token, status){

                // check status code
                if( status != 200) {
                    Popup.error("Couldn't get token, PayPal and Credit Card option will be disabled.");
                    return;
                }

                // init braintree to get nonce
                braintree.setup(token, 'custom', {
                    paypal: {
                        singleUse: true, 
                        amount: $rootScope.globals.selectedMoney.amount, 
                        currency: 'SGD', 
                        locale: 'en_us', 
                        headless: true, 
                    },
                    onPaymentMethodReceived: function (obj) {
                        $scope.payWithPayPal(obj);
                    },
                    onReady: function (integration) {
                        paypal_checkout = integration;

                        // braintree is initialized, enable payment buttons
                        $scope.$apply(function(){
                            $scope.getting_token = false;
                        });
                    },
                });
            });

        }


        /**
         * watcher for processing_payment variable
         */
        $scope.$watchGroup(['processing_payment', 'getting_token'], function() {
            if( $scope.processing_payment || $scope.getting_token ){
                Preloader.open();
            }
            else{
                Preloader.close();
            }
        });

    }]);